import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';

import { ErrorReportingService } from '®shared/reporting/error-reporting.service';

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(private errorReportingService: ErrorReportingService) {
    super();
  }
  handleError(error: any) {
    const reportableError = getReportableError(error);
    if (reportableError) {
      super.handleError(error);
      this.errorReportingService.reportToInstana(reportableError);
    } else {
      // eslint-disable-next-line no-console
      console.warn('😡 Non-fatal error', error);
    }
  }
}

/**
 * Given an error, return the error if it should be reported, or
 * return null if the error should not be reported.
 *
 * @param  {any} error An error
 * @return {any}       An error - if it should be reported - or null
 */
function getReportableError(error: any): any | null {
  if (error && error.rejection) {
    const rejectionError = getReportableError(error.rejection);
    return rejectionError ? error : null;
  } else if (error instanceof HttpErrorResponse) {
    switch (error.status) {
      case 401:
      case 403:
      case 404: {
        return null;
      }
      default: {
        return error;
      }
    }
  }
  return error;
}
